<div *ngIf="visible" class="container pane-bg-color">
  <div class="header">
    {{title}}
    <div id="close-button" (click)="close()"></div>
  </div>
  <ng-content></ng-content>
</div>
